$(function() {
  $('.bs__option').click(function(e){
    e.stopPropagation();
    bs_i = $(this).parent().attr('id').split("s")[1];
    bs_id = $(this).attr('id');
    text = $(this).find('.birthstone-text').text();
    arrow = "#bs" + bs_i + "_arrow";
    $(this).parent().removeClass('popout-list--visible');
    
    selected_text = '#selected_birthstone_text' + bs_i;
    
    selected_swatch = '#selected_swatch' + bs_i;
    
    bs_value = '#bs' + bs_i + "_value";
    
    $(this).addClass('is-active');
    
    new_month_class = bs_id.split("_")[0];
    
    $(arrow).css('transform', 'rotateX(0deg)');
    $(selected_text).text(text)

    
    if(bs_i == '_1'){
      old_active = '#' + oldBS_1 + '_1';
      
      $(old_active).removeClass('is-active')
      newBS_1 = new_month_class;
      $(selected_swatch).removeClass(oldBS_1);
      oldBS_1 = newBS_1;
    }else{
      old_active = '#' + oldBS_2 + '_2';
      $(old_active).removeClass('is-active')
      newBS_2 = new_month_class;
      $(selected_swatch).removeClass(oldBS_2);
      oldBS_2 = newBS_2;
    }
    
    $(selected_swatch).addClass(new_month_class);
    $(bs_value).val(text);

    
  });

  $('#bs_engrave_input').on("input", function() {
      $('#bs_engrave_value').val($(this).val());
  });

});